import React from "react";
import { Link } from "react-router-dom";
import { productOfTheYear } from "../../../assets/images";
import ShopNow from "../../designLayouts/buttons/ShopNow";
import Image from "../../designLayouts/Image";

const YearProduct = () => {
  return (
    <Link to="/shop">
      <div className="relative w-full h-80 mb-20 bg-[#f3f3f3] font-titleFont">
        
        <Image
          className="w-full h-full object-cover"
          imgSrc={productOfTheYear}
        />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center bg-black bg-opacity-25">
          <h1 className="text-4xl font-semibold text-white">
            Product of The Year
          </h1>
          <p className="text-lg font-normal text-white max-w-[600px] mt-4">
          This year, our air conditioners achieved the highest sales even without any discounts.
          </p>
          <div className="mt-6">
            <ShopNow />
          </div>
        </div>
      </div>
    </Link>
  );
};

export default YearProduct;
